import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Small persisted UI state for the version/update surface. Keyed by the remote
 * commit so a fresh deploy re-arms both the banner and the "Was ist neu" dialog.
 */
interface VersionUiState {
  /** Remote commit the "reload" banner was dismissed for. */
  dismissedCommit: string | null;
  /** Remote commit the "Was ist neu" dialog was already shown for. */
  seenWhatsNewCommit: string | null;
  dismissBanner: (commit: string) => void;
  markWhatsNewSeen: (commit: string) => void;
}

export const useVersionUiStore = create<VersionUiState>()(
  persist(
    (set) => ({
      dismissedCommit: null,
      seenWhatsNewCommit: null,
      dismissBanner: (commit) => set({ dismissedCommit: commit }),
      markWhatsNewSeen: (commit) => set({ seenWhatsNewCommit: commit }),
    }),
    { name: "version-ui-storage" }
  )
);
